import { render } from "./HeaderMenuComponent.vue?vue&type=template&id=0212c947&scoped=true"
import script from "./HeaderMenuComponent.vue?vue&type=script&lang=js"
export * from "./HeaderMenuComponent.vue?vue&type=script&lang=js"

import "./HeaderMenuComponent.vue?vue&type=style&index=0&id=0212c947&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0212c947"]])

export default __exports__